import createClient, { Middleware } from 'openapi-fetch'
import type { paths as otBrukerPaths } from './api-ot-bruker'
import type { paths as otUngdomPaths } from './api-ot-ungdom'
import type { paths as filterPaths } from './api-filter'
import type { paths as kodeverkPaths } from './api-kodeverk'
import type { paths as soknadPaths } from './api-soknad'
import type { paths as otNotatPaths } from './api-ot-notat'
import type { paths as meldingerPaths } from './api-meldinger'
import type { paths as oppgaverPaths } from './api-oppgaver'
import type { paths as sentraleOppgaverPaths } from './api-sentrale-oppgaver'
import { useAuthStore } from '@/modules/auth/store'

const authMiddleware: Middleware = {
  async onRequest({ request }) {
    const { getAccessToken } = useAuthStore()

    const token = await getAccessToken(false)
    if (token) {
      request.headers.set('Authorization', `Bearer ${token}`)
    } else {
      throw new Error('Access token unavailable')
    }
  }
}

const kodeverkClient = createClient<kodeverkPaths>({ baseUrl: '/vigo-ot' })
const otBrukerClient = createClient<otBrukerPaths>({ baseUrl: '/vigo-ot' })
const otUngdomClient = createClient<otUngdomPaths>({ baseUrl: '/vigo-ot' })
const otSoknadClient = createClient<soknadPaths>({ baseUrl: '/vigo-ot' })
const otNotatClient = createClient<otNotatPaths>({ baseUrl: '/vigo-ot' })
const meldingerClient = createClient<meldingerPaths>({ baseUrl: '/vigo-ot' })
const oppgaverClient = createClient<oppgaverPaths>({ baseUrl: '/vigo-ot' })
const filterClient = createClient<filterPaths>({ baseUrl: '/vigo-ot' })
const sentraleOppgaverClient = createClient<sentraleOppgaverPaths>({ baseUrl: '/vigo-ot' })

kodeverkClient.use(authMiddleware)
otBrukerClient.use(authMiddleware)
otUngdomClient.use(authMiddleware)
otSoknadClient.use(authMiddleware)
otNotatClient.use(authMiddleware)
meldingerClient.use(authMiddleware)
oppgaverClient.use(authMiddleware)
filterClient.use(authMiddleware)
sentraleOppgaverClient.use(authMiddleware)

export {
  otBrukerClient,
  kodeverkClient,
  otUngdomClient,
  otSoknadClient,
  otNotatClient,
  meldingerClient,
  oppgaverClient,
  filterClient,
  sentraleOppgaverClient
}
